import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import TrustSection from './components/TrustSection';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import JsonLd from '@/components/base/JsonLd';
import { useSeo, SITE_URL, SITE_LOGO } from '@/hooks/useSeo';

export default function Home() {
  const { t, i18n } = useTranslation();

  useSeo({
    title: t('home.metaTitle'),
    description: t('home.metaDescription'),
    keywords:
      'AllChinaBuy spreadsheet, AllChinaBuy finds, AllChinaBuy QC, AllChinaBuy shipping, product spreadsheet',
    path: '/',
    lang: i18n.language,
  });

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'AllChinaBuy Spreadsheet',
    url: `${SITE_URL}/`,
    description:
      'Independent guide to finding products, checking quality and shopping smarter with the AllChinaBuy spreadsheet.',
    inLanguage: ['en', 'fr', 'da', 'de'],
    publisher: {
      '@type': 'Organization',
      name: 'AllChinaBuy Spreadsheet',
      logo: { '@type': 'ImageObject', url: SITE_LOGO },
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AllChinaBuy Spreadsheet',
    url: `${SITE_URL}/`,
    logo: { '@type': 'ImageObject', url: SITE_LOGO },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <TrustSection />
        <ArticlesSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}